"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const contexts_1 = require("@App/contexts");
const PayeeBankingInfo_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/PayeeBankingInfo"));
const mobx_react_1 = require("mobx-react");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const dayjs_1 = __importDefault(require("dayjs"));
const RightsholderMaintenanceBankingTab = () => {
    const { popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [isBankingLocked, setBankingLocked] = (0, react_1.useState)(true);
    const checkBankingLocked = () => {
        const currentDay = (0, dayjs_1.default)().tz('America/Chicago').date();
        if (currentDay >= 3 && currentDay <= 14) {
            setBankingLocked(true);
            popupStore.setAlertData('Updating banking and tax information is temporarily unavailable from the 3rd - 14th each month.', false, false);
        }
        else {
            setBankingLocked(false);
        }
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_banking');
        checkBankingLocked();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "rightsholder-maintenance-banking-tab" }, !isBankingLocked && react_1.default.createElement(PayeeBankingInfo_1.default, null))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderMaintenanceBankingTab);
